export function GraduationDetails() {
  return (
    <div className="space-y-8">
      <h2 className="text-2xl font-bold text-gray-900">Graduation Details</h2>
      
      <div className="bg-white rounded-lg p-8 border border-gray-200">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* School Information */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              School Name <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
              placeholder="Enter school name"
            />
          </div>

          {/* Degree Type */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Degree Type <span className="text-red-500">*</span>
            </label>
            <select
              className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
            >
              <option value="">Select degree type</option>
              <option value="high_school">High School Diploma</option>
              <option value="associates">Associate's Degree</option>
              <option value="bachelors">Bachelor's Degree</option>
              <option value="masters">Master's Degree</option>
              <option value="doctorate">Doctorate</option>
              <option value="certificate">Certificate</option>
              <option value="other">Other</option>
            </select>
          </div>

          {/* Field of Study */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Field of Study
            </label>
            <input
              type="text"
              className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
              placeholder="e.g., Computer Science, Business"
            />
          </div>

          {/* Graduation Date */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Graduation Date <span className="text-red-500">*</span>
            </label>
            <input
              type="date"
              className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
            />
          </div>

          {/* GPA */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              GPA
            </label>
            <input
              type="number"
              step="0.01"
              min="0"
              max="4"
              className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
              placeholder="e.g., 3.75"
            />
          </div>

          {/* Honors/Distinctions */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Honors/Distinctions
            </label>
            <input
              type="text"
              className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
              placeholder="e.g., Cum Laude, Honors"
            />
          </div>

          {/* Location */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Location <span className="text-red-500">*</span>
            </label>
            <input
              type="text"
              className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
              placeholder="City, State/Province, Country"
            />
          </div>

          {/* Ceremony Venue */}
          <div className="space-y-3">
            <label className="block text-lg text-gray-700 font-medium">
              Ceremony Venue
            </label>
            <input
              type="text"
              className="w-full p-4 text-lg rounded-lg bg-gray-50 border border-gray-200"
              placeholder="e.g., University Auditorium"
            />
          </div>
        </div>
      </div>
    </div>
  )
} 